import { Paper, Typography, Box } from '@mui/material';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { tokens } from '../../../theme/theme';

export default function ThreatTimeline({ data }) {
  if (!data?.length) return null;
  return (
    <Paper sx={{ p: 2.4, height: '100%' }}>
      <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>
        24H Threat Activity — Acted On vs Awaiting Triage
      </Typography>
      <Box sx={{ height: 240, mt: 1 }}>
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="blockedGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={tokens.brand.main} stopOpacity={0.35} />
                <stop offset="95%" stopColor={tokens.brand.main} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="flaggedGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={tokens.severity.high} stopOpacity={0.35} />
                <stop offset="95%" stopColor={tokens.severity.high} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke={tokens.border} vertical={false} />
            <XAxis dataKey="hour" tick={{ fill: tokens.text.muted, fontSize: 10 }} axisLine={{ stroke: tokens.border }} tickLine={false} interval={2} />
            <YAxis tick={{ fill: tokens.text.muted, fontSize: 10 }} axisLine={false} tickLine={false} />
            <Tooltip contentStyle={{ backgroundColor: tokens.bg.elevated, border: `1px solid ${tokens.border}`, borderRadius: 8, fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 11, color: tokens.text.secondary }} />
            <Area type="monotone" dataKey="blocked" name="Acted On" stroke={tokens.brand.main} fill="url(#blockedGrad)" strokeWidth={2} />
            <Area type="monotone" dataKey="flagged" name="Awaiting Triage" stroke={tokens.severity.high} fill="url(#flaggedGrad)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
}
